import styled from "styled-components";

const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 2rem 2rem 0 2rem;
  position: relative;
  z-index: 2;
  margin-bottom: 2rem;
  @media screen and (max-width: 992px) {
    padding: 1rem 2rem;
  }
  @media screen and (max-width: 768px) {
    padding: 0 2rem;
    margin-top: 2rem;
  }
`;
const StyledContainer = styled.div`
  max-width: 1280px;
  width: 100%;
  display: flex;
  align-items: flex-start;
  h3 {
    font-size: 1.6rem;
    line-height: 2rem;
    border-left: 5px solid #604aff;
    padding-left: 1rem;
  }
  p {
    padding-left: 1rem;
    font-size: 1.2rem;
    line-height: 2rem;
  }
  @media screen and (max-width: 992px) {
    flex-direction: column;
  }
  > div {
    flex: 1 1 33%;
    padding: 0 1rem;
    @media screen and (max-width: 768px) {
      padding: 0 0;
    }
  }
`;

const SectionTwo = () => {
  return (
    <StyledWrapper>
      <StyledContainer>
        <div>
          <h3>Deletion for social networks</h3>
          <p>
            A continually expanding reach, supporting deletion for more and more social media
            applications
          </p>
        </div>
        <div>
          <h3>Deleting various content</h3>
          <p>Delete content like images, post, comments, follows, and likes.</p>
        </div>
        <div>
          <h3>Scheduled deletion</h3>
          <p>Specify what content to delete and set a recurring schedule for it for less hassle.</p>
        </div>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default SectionTwo;
